import ActiveAlarmsTable from './ActiveAlarmsTable';
export default ActiveAlarmsTable;
